<template>
  <el-dialog
    class="no-select"
    :title="$t('选择设备')"
    v-bind="$props"
    v-on="$listeners"
  >
    <div class="d-flex justify-between" style="height: 50vh">
      <div class="space-model">
        <div class="space-title font-bold">{{ $t('空间结构') }}</div>
        <el-scrollbar style="height:92%">
          <el-tree
            ref="spaceTree"
            node-key="id"
            :data="spaceData"
            :props="defaultProps"
            :expand-on-click-node="false"
            default-expand-all
            highlight-current
            v-bind="$props"
            v-on="$listeners"
          />
        </el-scrollbar>
      </div>
      <div class="device-model">
        <div class="device-title font-bold">{{ $t('选择设备') }}</div>
        <template v-if="deviceData.length">
          <el-scrollbar style="height:92%">
            <el-collapse :value="Array.from(new Array(100).keys())">
              <el-collapse-item
                v-for="(groupItem, groupIndex) in deviceData"
                :key="groupIndex"
                :title="groupItem.echoMap.categoryDictCode"
                :name="groupIndex"
              >
                <span
                  v-for="(labelItem, labelIndex) in groupItem.children"
                  :key="labelIndex"
                  class="label text-ellipsis"
                  :class="{active: deviceId === labelItem.id}"
                  @click="handleDeviceClick({ ...labelItem, categoryDictName: groupItem.echoMap.categoryDictCode})"
                  @dblclick="handleDeviceDblclick({ ...labelItem, categoryDictName: groupItem.echoMap.categoryDictCode})"
                ><span v-if="showStatus" class="dot" :style="{backgroundColor: deviceStatusMap[labelItem.runStatus || 'null'].barColor}"></span>{{ labelItem.name }}</span>
              </el-collapse-item>
            </el-collapse>
          </el-scrollbar>
        </template>
        <template v-else>
          <el-empty :description="$t('暂无设备')" />
        </template>
      </div>
    </div>
    <div class="mt-3">
      <span class="mr-1">{{ $t('快速选择：') }}</span>
      <span
        v-for="(labelItem, labelIndex) in eamDeviceSelectData"
        :key="labelIndex"
        class="device-label"
        :class="{active: labelItem.deviceId === deviceId}"
        @click="handleDeviceClick({
          id: labelItem.deviceId,
          name: labelItem.deviceName,
          sn: labelItem.sn,
          deviceBrandId: labelItem.deviceBrandId,
          categoryDictCode: labelItem.categoryDictCode,
          categoryDictName: labelItem.categoryDictName,
          spaceName: labelItem.spaceName
        })"
        @dblclick="handleDeviceDblclick({
          id: labelItem.deviceId,
          name: labelItem.deviceName,
          sn: labelItem.sn,
          deviceBrandId: labelItem.deviceBrandId,
          categoryDictCode: labelItem.categoryDictCode,
          categoryDictName: labelItem.categoryDictName,
          spaceName: labelItem.spaceName
        })"
      >{{ labelItem.deviceName }}</span>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button class="cancle-btn" @click="cancleDevice">{{ $t('取 消') }}</el-button>
      <el-button type="primary" @click="confirmDevice">{{ $t('确 定') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { Tree, Dialog } from 'element-ui';
import { DEVICE_STATUS_MAP } from '@klinx/ccs/src/config/device/common';

export default {
  name: 'DeviceSelect',
  components: { ElTree: Tree, ElDialog: Dialog },
  props: {
    ...Dialog.props,
    ...Tree.props,
    visible: {
      type: Boolean,
      default: true
    },
    // 空间数据
    spaceData: {
      type: Array,
      default: () => []
    },
    // 设备数据
    deviceData: {
      type: Array,
      default: () => []
    },
    // 是否显示设备状态
    showStatus: {
      type: Boolean,
      default: true
    },
    // 设备空间
    spaceName: {
      type: String,
      default: ''
    },
    isNewColour: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      deviceStatusMap: DEVICE_STATUS_MAP,
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      deviceId: '',
      deviceName: '',
      selDeviceId: '',
      selDeviceName: '',
      seldeviceSn: '',
      seldeviceBrandId: '',
      selCategoryDictCode: '',
      selCategoryDictName: '',
      selSpaceName: '',
      eamDeviceSelectData: [],
      deviceSn: '',
      deviceBrandId: '',
      categoryDictCode: '',
      categoryDictName: ''
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.eamDeviceSelectData = JSON.parse(localStorage.getItem('eamDeviceSelectData')) || [];
      } else {
        this.deviceName = this.selDeviceName;
        this.deviceId = this.selDeviceId;
        this.deviceSn = this.seldeviceSn;
        this.deviceBrandId = this.seldeviceBrandId;
        this.categoryDictCode = this.selCategoryDictCode;
        this.categoryDictName = this.selCategoryDictName;
      }
    }
  },
  methods: {
    handleDeviceClick(e) {
      this.deviceId = e.id;
      this.deviceName = e.name;
      this.deviceSn = e.sn;
      this.deviceBrandId = e.deviceBrandId;
      this.categoryDictCode = e.categoryDictCode;
      this.categoryDictName = e.categoryDictName;
      this.selSpaceName = e.spaceName || this.spaceName;
    },
    handleDeviceDblclick(e) {
      this.handleDeviceClick(e);
      this.confirmDevice();
    },
    confirmDevice() {
      if (!this.deviceId) {
        return this.$message.warning(this.$t('请选择设备'));
      }
      // 如果快速选择中不存在这个设备，则存到localStorage中
      if (!(JSON.parse(localStorage.getItem('eamDeviceSelectData')) || []).some(v => v.deviceId === this.deviceId)) {
        localStorage.setItem('eamDeviceSelectData', JSON.stringify([{
          deviceName: this.deviceName,
          deviceId: this.deviceId,
          sn: this.deviceSn,
          deviceBrandId: this.deviceBrandId,
          categoryDictCode: this.categoryDictCode,
          categoryDictName: this.categoryDictName,
          spaceName: this.selSpaceName
        }, ...JSON.parse(localStorage.getItem('eamDeviceSelectData')) || []].slice(0, 5)));
      }
      this.selDeviceName = this.deviceName;
      this.selDeviceId = this.deviceId;
      this.seldeviceSn = this.deviceSn;
      this.seldeviceBrandId = this.deviceBrandId;
      this.selCategoryDictCode = this.categoryDictCode;
      this.selCategoryDictName = this.categoryDictName;
      this.$emit('confirm', {
        deviceName: this.deviceName,
        deviceId: this.deviceId,
        deviceSn: this.deviceSn,
        deviceBrandId: this.deviceBrandId,
        categoryDictCode: this.categoryDictCode,
        categoryDictName: this.categoryDictName,
        spaceName: this.selSpaceName
      });
      this.$emit('update:visible', false);
    },
    // 取消选择设备
    cancleDevice() {
      this.$emit('update:visible', false);
    }
  }
};
</script>

<style lang='scss' scoped>
::v-deep .el-collapse-item {
  margin-bottom: 12px;
  border-radius: 1px;

  .el-collapse-item__wrap {
    border-bottom: none;
  }

  .el-collapse-item__content {
    padding: 10px 12px;
    border: 1px solid #F2F2F2;
    background: #FFF;
  }

  .el-collapse-item__header {
    padding-left: 12px;
    border-bottom: none;
    background-color: #FAFAFA;
  }
}

.space-model {
  width: 30%;
  border: 1px solid #F0F0F0;
  .space-title {
    padding: 10px;
    background: #FAFAFA;
    border-bottom: 1px solid #F0F0F0;
  }
}

.device-model{
  width: 68%;
  border: 1px solid #F0F0F0;
  .device-title{
    padding: 10px;
    background: #FAFAFA;
    border-bottom: 1px solid #F0F0F0;
  }
  .label{
    display: inline-block;
    margin-right: 20px;
    width: 160px;
    font-weight: normal;
    cursor: pointer;
    &.active{ background: $main-hover-light; }
    &:hover{ color: $main; }
    .dot{
      display: inline-block;
      width: 8px;
      height: 8px;
      margin: 0 5px;
      border-radius: 50%;
    }
  }
  .el-collapse{
    padding: 20px;
    .el-collapse-item__header{
      height: 30px;
    }
    .el-collapse-item__content{
      background: #fff;
      border: 1px solid #F2F2F2;
    }
  }
}

.device-label{
  background: #FAFAFA;
  border: 1px solid #D9D9D9;
  border-radius: 2px;
  padding: 2px 8px;
  cursor: pointer;
  margin-right: 10px;
  &.active{
    background: $main-hover-light;
    border: 1px solid $main;
  }
}
</style>
<style lang="scss">
.confirm-btn {
  background-color: $main !important;
  border-color: $main !important;
}
.cancle-btn {
  &:hover {
    color: $main;
    border-color: $main-hover;
    background-color: $main-hover-light;
  }
}
</style>
